import {
  ProgressBarColor, ProgressBarState
} from '../../../../constants/timeProgressBar';

type GetStateProps = {
  currentTime: number,
  alertRange: number,
  targetTime: number,
  isCurrentlyRunning: boolean,
  shouldShowIntervals?: boolean
}

type GetStateParams = {
  state: ProgressBarState,
  color: ProgressBarColor,
}

export const getState = ({
  currentTime, alertRange, targetTime, isCurrentlyRunning, shouldShowIntervals
}: GetStateProps): GetStateParams => {
  const expireBoundary = targetTime + alertRange;

  if (currentTime >= expireBoundary) {
    return {
      state: ProgressBarState.EXPIRED,
      color: shouldShowIntervals ?
        ProgressBarColor.ALERT_RANGE :
        ProgressBarColor.EXPIRED
    };
  }

  if (currentTime > targetTime && currentTime < expireBoundary) {
    return {
      state: ProgressBarState.ALERT,
      color: ProgressBarColor.ALERT_RANGE
    };
  }

  return {
    state: ProgressBarState.NORMAL,
    color: isCurrentlyRunning ?
      ProgressBarColor.DEFAULT_CURRENT_TASK :
      ProgressBarColor.DEFAULT
  };
};
